// Random lowercase letter
const randomLetter = String.fromCharCode(97 + Math.floor(Math.random() * 26));
//console.log(randomLetter); // a-z

// Random uppercase letter
const randomUpper = String.fromCharCode(65 + Math.floor(Math.random() * 26));
//console.log(randomUpper); // A-Z

// Random alphanumeric character
export function getRandomChar() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return chars.charAt(Math.floor(Math.random() * chars.length));
}
